






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseCommande from '@/components/administration/commande/edit/EditBaseCommande.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloCommande } from '@/models/alo/AloCommande'
import { AloCommande } from '@/models/alo/AloCommande'

@Component({
  name: 'EditContent',     
  components:{EditBaseCommande}
})
export default class EditContent extends Vue {
      
  private commande:AloCommande = getDefaultAloCommande()

  edit(item:AloCommande) {    
    this.commande = (this.$refs.baseEdit as EditBaseCommande).edit(item)    
  }

 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
